import { Permission } from '@today/types'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'
import { ImportDetailPage } from './ImportDetailPage'
import { ImportsListPage } from './ImportsListPage'

export { ImportDetailPage, ImportsListPage }

/**
 * The import monitoring routes under `/t/:slug/admin` (TO-399): both need
 * `import_execution.read`; without it the Forbidden page renders. The
 * original-file download is gated inside the drill-down on its own permission.
 */
export const importsPageRoutes: RouteObject[] = [
	{
		path: 'imports',
		element: (
			<RequirePermission permission={Permission.IMPORT_EXECUTION_READ}>
				<ImportsListPage />
			</RequirePermission>
		),
	},
	{
		path: 'imports/:executionId',
		element: (
			<RequirePermission permission={Permission.IMPORT_EXECUTION_READ}>
				<ImportDetailPage />
			</RequirePermission>
		),
	},
]
